module.exports = __webpack_public_path__ + "account_circle_filled-v1-3d92cecb.svg";